import React, { useMemo } from 'react';
import styled from 'styled-components';
import useStore from '~/store';
import { nf } from '~/utils';

const TooltipWrapper = styled.div`
  position: absolute;
  z-index: 300;
  width: 225px;
  pointer-events: none;
  user-select: none;
  box-shadow: 0px 0px 5px 0px rgba(50, 50, 50, 0.3);
  border-radius: 2px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 8px 0 8px;
  font-size: 12px;
`;

const TooltipHeadline = styled.div`
  font-weight: bold;
`;

const TooltipSubline = styled.div`
  color: #777;
`;

const TooltipItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #ddd;
  color: ${(p) => p.color || 'black'};
  &:last-child {
    border-bottom: none;
  }
`;

const TooltipKey = styled.div``;

const TooltipValue = styled.div`
  font-weight: bold;
  min-width: 50px;
  text-align: right;
`;

const storeSelector = (state) => ({
  isVisible: state.tooltipVisible,
  position: state.tooltipPosition,
  data: state.tooltipData,
  currentView: state.currentView,
});

export default function Tooltip() {
  const { isVisible, position, data, currentView } = useStore(storeSelector);

  const wrapperStyle = useMemo(
    () => ({ display: isVisible ? 'block' : 'none', top: position[1] + 12, left: position[0] - 112 }),
    [isVisible, position, data]
  );

  if (!isVisible || !data || !position) {
    return null;
  }

  const ageLabel = data.data.Alter >= 85 ? `>85` : `${data.data.Alter}`;

  return (
    <TooltipWrapper style={wrapperStyle}>
      <TooltipHeadline>{data.sheet.name}</TooltipHeadline>
      <TooltipSubline>{ageLabel} Jahre</TooltipSubline>
      <TooltipSubline>{currentView.description}</TooltipSubline>
      <TooltipItem color={data.color} style={{ fontWeight: 'bold' }}>
        <TooltipKey>{data.columnName}</TooltipKey>
        <TooltipValue>{nf(data.data[data.columnName])}</TooltipValue>
      </TooltipItem>
      <TooltipItem>
        <TooltipKey>
          alle {data.columnsLabel.replace('geleistete', 'geleisteten').replace('erhaltene', 'erhaltenen')}:
        </TooltipKey>
        <TooltipValue>{nf(data.sum)}</TooltipValue>
      </TooltipItem>
    </TooltipWrapper>
  );
}
